import type {} from "@lit/react";
import { SelectListBox as SelectListBoxElement, } from "@vaadin/select/vaadin-select-list-box.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { SelectListBoxElement };
export type SelectListBoxEventMap = Readonly<{}>;
const events = {} as SelectListBoxEventMap;
export type SelectListBoxProps = WebComponentProps<SelectListBoxElement, SelectListBoxEventMap>;
export const SelectListBox = createComponent({
    elementClass: SelectListBoxElement,
    events,
    react: React,
    tagName: "vaadin-select-list-box",
});
